import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc65fa00&scoped=true&lang=pug"
import script from "./code.js?vue&type=script&lang=js&external"
export * from "./code.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=dc65fa00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc65fa00",
  null
  
)

export default component.exports